export enum ApiRoutesEnum {
  LOGIN = "Authentication/v1/LogIn",
  FUNCIONALITIES = "Users/v1/GetFuncionalities",
  GET_MASTERS_BY_ID = "Master/v1/GetMastersById",
  GET_MASTERS_BY_NAME = "Master/v1/GetMastersByName",
  SAVE_CUSTOMER = "Users/v1/CreateUser",
  SAVE_CUSTOMER_USER = "Users/v1/CreateCustomerUser",
  CREATE_USER_STAFF = "Users/v1/CreateUserStaff",
  CREATE_DISTRIBUTOR_CUSTOMER = "Users/v1/CreateDistributorCustomer",
  GET_CURRENT_USER = "Users/v1/GetCurrentUser",
  GET_LIST_CUSTOMERS = "Users/v1/GetListUsers",
  GetCustomersForTransfer = "Users/v1/GetCustomersForTransfer",
  GetCustomersWithTranfers = "Users/v1/GetCustomersWithTranfers",
  GetUserPlanActiveDevices = "Inventory/v1/GetUserPlanActiveDevices/",
  GET_PERCENTEGE_ALERT_BY_USER = "Users/v1/GetPercentageAlertByUser",
  GetAllPlans = "Plans/v1/GetAllPlans",
  getPlanById = "Plans/v1/GetPlanById/",
  CreatePlan = "Plans/v1/CreatePlan",
  UpdatePlan = "Plans/v1/UpdatePlan",
  UPDATE_CUSTOMER_STATUS = "Users/v1/UpdateUserStatus",
  UPDATE_USER_PERCENTAGE_ALERT = "Users/v1/UpdateUserPercentageAlert",
  UpdateSendThresholdConsumptionAlert = "Users/v1/UpdateSendThresholdConsumptionAlert",
  UPDATE_CUSTOMER = "Users/v1/UpdateUser",
  GET_USER_BY_ID = "Users/v1/GetUserById",
  GetUserByOriginalId = "Users/v1/GetUserByOriginalId/",
  SAVE_DEVICE = "Users/v1/CreateDevice",
  GET_LIST_DEVICES = "UserPlanDevice/v1/GetUserPlanDeviceByDetail",
  GET_ALL_PLANS_ASSIGN_PLAN = "Plans/v1/GetAllPlansAssignPlan",
  ASSIGN_PLAN = "Users/v1/CreateUserPlanDevice",
  GET_PLANS_BY_USERID = "Users/v1/GetPlansByUserId/",
  GET_LIST_USERS_OF_CUSTOMER = "Users/v1/GetListUsersOfCustomer/",
  GET_LIST_USERS_OF_STAFF = "Users/v1/GetListUsersOfStaff/",
  GET_LIST_CUSTOMERS_OF_DISTRIBUTOR = "Users/v1/GetListCustomersOfDistributor/",
  UPDATE_USER_PLAN_STATUS = "Users/v1/UpdateUserPlanStatus",
  GET_DEVICE_BY_ICCID = "PlanDevice/v1/GetDeviceByICCID",
  CREATE_DEVICE = "Devices/v1/CreateDevice",
  UPDATE_DEVICE = "PlanDevice/v1/UpdateDevice",
  CREATE_PLAN_DEVICE = "PlanDevice/v1/CreatePlanDevice",
  GET_DEVICES_PLAN_BY_ID_PLAN = "PlanDevice/v1/GetDevicesPlanByIdPlan/",
  UPDATE_PLAN_DEVICE_STATUS = "PlanDevice/v1/UpdatePlanDeviceStatus",
  GET_LIST_PARTNERS = "Partners/v1/GetPartnersList",
  SAVE_PARTNER = "Partners/v1/CreatePartner",
  VALIDATE_EMAIL_EXIST = "Authentication/v1/ValidateEmailExist",
  UPDATE_PASSWORD = "Users/v1/UpdatePassword",
  GET_LIST_CUSTOMERS_BY_PARTNER_ID = "Partners/v1/GetListCustomersByPartnerId",
  GET_LIST_CUSTOMERS_AVAILABLES = "Partners/v1/GetListCustomersAvailables",
  ADD_CUSTOMERS_PARTNER = "Partners/v1/AddCustomersPartner",
  CLEAR_CUSTOMERS_PARTNER = "Partners/v1/ClearCustomersPartner",
  GET_ALL_PARTNERS_AVAILABLES = "Partners/v1/GetAllPartnersAvailables",
  UPDATE_CUSTOMERS_PARTNER = "Partners/v1/UpdateCustomersPartner",
  GET_USER_BY_EMAIL = "Authentication/v1/GetUserByEmail",
  VERIFY_CODE = "Authentication/v1/VerifyCode",
  SenVerificationCode = "Authentication/v1/SenVerificationCode",
  RESEND_VERIFICATION_CODE = "Authentication/v1/ResendVerificationCode",
  SEND_VERIFICATION_EMAIL = "Authentication/v1/SendVerificationEmail",
  VERIFIY_CODE_EMAIL = "Authentication/v1/VerifyCodeEmail",
  GET_ALL_PLANS_TYPE_PLAN = "Plans/v1/GetAllPlansTypePlan",
  UPDATE_USER_PLAN = "UserPlanDevice/v1/UpdateUserPlan",
  //GET_USER_SUMMARY = "Users/v1/GetUserSummary",

  getCustomerPlans = "Customers/v1/getCustomerPlans/",
  getCustomerPlanByUserPlanId = "Customers/v1/getCustomerPlanByUserPlanId/",
  getAllUsagesByUserPlanId = "Customers/v1/getAllUsagesByUserPlanId/",


  getDevicesNotYetAssignedToAPlan = "Customers/v1/getDevicesNotYetAssignedToAPlan",
  GET_PARTNERS_SUMMARY = "Partners/v1/GetPartnersSummary",
  GET_ALL_USAGES_BY_ID_PLAN = "PlanDevice/v1/GetAllUsagesByIdPlan/",
  GET_ROLES = "Role/v1/GetRoles/",
  SAVE_USER_MANAGEMENT = "Users/v1/CreateUserManagement",
  GET_LIST_USERS_MANAGEMENT = "Users/v1/GetListUsersManagement",
  UPDATE_USER_MANAGEMENT = "Users/v1/UpdateUserManagement",
  GET_LIST_ROLES = "Role/v1/GetListRoles/",
  UPDATE_ROLE_STATUS = "Role/v1/UpdateRoleStatus",
  CREATE_ROLE = "Role/v1/CreateRole",
  GET_ROLE_BY_ID = "Role/v1/GetRoleById",
  UPDATE_ROLE = "Role/v1/UpdateRole",
  GET_MODULE_BY_ROLE = "Role/v1/GetModuleByRole",
  UPDATE_MODULE_BY_ROLE = "Role/v1/UpdateModuleByRole",
  UPDATE_PLAN_DEVICE = "PlanDevice/v1/UpdatePlanDevice",
  EXPORT_TO_EXCEL_LIST_CUSTOMERS = "Export/v1/ExportToExcelListCustomers",
  ExportToExcelListOfInventory = "Export/v1/ExportToExcelListOfInventory",
  GenericExportToExcel = "Export/v1/GenericExportToExcel",
  EXPORT_TO_EXCEL_LIST_DEVICES = "Export/v1/ExportToExcelListDevices",
  EXPORT_TO_EXCEL_LIST_PLAN_DEVICES = "Export/v1/ExportToExcelListPlanDevices",
  EXPORT_TO_EXCEL_LIST_PLAN_DEVICES_ANNUAL = "Export/v1/ExportToExcelListPlanDevicesAnnual",
  EXPORT_TO_EXCEL_LIST_PLANS = "Export/v1/ExportToExcelListPlans",
  EXPORT_TO_EXCEL_LIST_CUSTOMER_PLANS = "Export/v1/ExportToExcelListCustomerPlans",
  EXPORT_TO_EXCEL_LIST_PARTNERS = "Export/v1/ExportToExcelListPartners",
  EXPORT_TO_EXCEL_LIST_DISTRIBUTORS = "Export/v1/ExportToExcelListDistributors",
  EXPORT_TO_EXCEL_LIST_PARTNERS_BY_DISTRIBUTORID = "Export/v1/ExportListPartnersByDistributorId",
  EXPORT_TO_EXCEL_LIST_USERS_MANAGEMENT = "Export/v1/ExportToExcelListUsersManagement",
  EXPORT_TO_EXCEL_LIST_CUSTOMERS_BY_PARTNERID = "Export/v1/ExportListCustomersByPartnerId",
  EXPORT_TO_EXCEL_LIST_PLAN_DEVICES_CONSOLIDATED = "Export/v1/ExportToExcelListPlanDevicesConsolidated",
  CREATE_NOTIFICATION = "Notification/v1/CreateNotification",
  GET_NOTIFICATION = "Notification/v1/GetNotification",
  CALCULATE_PRORATION_START = "Billing/v1/CalculateProrationStart",
  CALCULATE_PRORATION_END = "Billing/v1/CalculateProrationEnd",
  GET_RATE_PLANS = "Inventory/v1/GetRatePlans",
  CreateSim = "Inventory/v1/CreateSim",
  GET_LIST_SIMS = "Inventory/v1/GetListSims",
  getAllUnassignedDevices = "Inventory/v1/getAllUnassignedDevices/",
  UPDATE_SIM_STATUS = "Inventory/v1/UpdateSimStatus",
  UPDATE_SIM = "Inventory/v1/UpdateSim",
  IMPORT_SIMS = "Inventory/v1/ImportSims",
  GET_LIST_SIMS_AVAILABLES = "Inventory/v1/GetListSimsAvailables",
  ADD_DEVICES_TO_PLAN = "Inventory/v1/AddDevicesToPlan",
  GetListPlansAvailables = "Inventory/v1/GetListPlansAvailables",
  UpdatePlanDevices = "Inventory/v1/UpdatePlanDevices",
  transferUnassignedCustomerDevices = "Inventory/v1/transferUnassignedCustomerDevices",
  revertDedviceTransferFromCustomer = "Inventory/v1/revertDedviceTransferFromCustomer",
  revertDedviceTransferFromUserPlan = "Inventory/v1/revertDedviceTransferFromUserPlan",
  GET_STATUS_SIMS = "Inventory/v1/GetStatusSims",
  GET_CARRIERS = "Inventory/v1/GetCarriers",
  GetPlanTypes = "Plans/v1/GetPlanTypes",
  GetPlanTypeById = "Plans/v1/GetPlanTypeById/",
  GetPlanFrequencies = "Plans/v1/GetPlanFrequencies",
  GET_LOGS_CALLBACK = "Inventory/v1/GetLogsCallback",
  UPDATE_SIMS = "Inventory/v1/UpdateSims",
  GET_TEMPLATE_CREATE_INVENTORY = "Inventory/v1/GetTemplateCreateInventory",
  GET_TEMPLATE_UPDATE_INVENTORY = "Inventory/v1/GetTemplateUpdateInventory",
  getDevicesByCustomer = "SendSMS/v1/getDevicesByCustomer",
  SendSMS = "SendSMS/v1",
  CanSendSMS = "Sidebar/CanSendSMS",
  GetUserPlanHistory = "Users/v1/GetUserPlanHistory/",
  GetDeviceByIccid = "Inventory/v1/GetDeviceByIccid/",
  UpdatePlanType = "Plans/v1/UpdatePlanType",
  CreatePlanType = "Plans/v1/CreatePlanType",
  GetThresholdSettings = "ThresholdSettings/v1/GetThresholdSettings",
  UpdateThresholdSetting = "ThresholdSettings/v1/UpdateThresholdSetting",
  GetCarrierApiSettings = "Settings/v1/GetSettingDetailsBySettingId/CarrierApiSettings",
  UpdateCarrierApiSetting = "Settings/v1/UpdateSettingDetail",

  FindCustomerPlanByICCID = "Customers/v1/findCustomerPlanByICCID/",
  FindCustomerPlans = "Customers/v1/findCustomerPlans/",
  GetCustomerDevices = "Customers/v1/getCustomerDevices/",
  GetDeviceConsumptions = "Customers/v1/getDeviceConsumptions/",


  LoadAuditData = "Audit/v1/LoadData",
  LoadNotes = "Notes/v1/Load",
  CreateNotes = "Notes/v1/Create",

  GET_LIST_DISTRIBUTORS = "Distributors/v1/GetDistributorsList",
  SAVE_DISTRIBUTOR = "Distributors/v1/CreateDistributor",
  GET_LIST_PARTNERS_BY_DISTRIBUTOR_ID = "Distributors/v1/GetListPartnersByDistributorId",
  GET_LIST_PARTNERS_AVAILABLES = "Distributors/v1/GetListPartnersAvailables",
  ADD_PARTNERS_DISTRIBUTOR = "Distributors/v1/AddPartnersDistributor",
  CLEAR_PARTNERS_DISTRIBUTOR = "Distributors/v1/ClearPartnersDistributor",
  GET_ALL_DISTRIBUTORS_AVAILABLES = "Distributors/v1/GetAllDistributorsAvailables",
  UPDATE_PARTNERS_DISTRIBUTOR = "Distributors/v1/UpdatePartnersDistributor",
  GET_DISTRIBUTORS_SUMMARY = "Distributors/v1/GetDistributorsSummary",
  GET_LIST_CUSTOMERS_BY_DISTRIBUTOR = "Distributors/v1/GetListCustomersByDistributorId",
  GET_LIST_CUSTOMERS_AVAILABLES_FOR_DISTRIBUTOR = "Distributors/v1/GetListCustomersAvailables",
  ADD_CUSTOMERS_DISTRIBUTOR = "Distributors/v1/AddCustomersDistributor",
  CLEAR_CUSTOMERS_DISTRIBUTOR = "Distributors/v1/ClearCustomersDistributor",
  UPDATE_CUSTOMERS_DISTRIBUTOR = "Distributors/v1/UpdateCustomersDistributor",

}
